var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.onClick}},[_c('v-icon',{staticClass:"mr-2"},[_vm._v("add")]),_vm._t("default",[_vm._v("Add New")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }